import gql from "graphql-tag";

export const GET_CLIENT_TYPES = gql`
  query ($entityId: String!) {
    getClientTypes(entityId: $entityId) {
      statusCode
      message
      data
    }
  }
`;

export const GET_CLIENT_USERS = gql`
  query ($entityId: String!) {
    getClientUsers(entityId: $entityId) {
      statusCode
      message
      data
    }
  }
`;

export const GET_DOCUMENT_REQUESTS = gql`
  query ($entityId: String!) {
    getDocumentRequests(entityId: $entityId) {
      statusCode
      message
      data
    }
  }
`;

export const CREATE_DOCUMENT_REQUEST = gql`
  mutation (
    $entityId: String!
    $challengeResponse: String!
    $request: documentRequest!
  ) {
    createDocumentRequest(
      entityId: $entityId
      challengeResponse: $challengeResponse
      request: $request
    ) {
      statusCode
      message
      data
    }
  }
`;

export const GET_DOCUMENT_TYPES = gql`
  query ($entityId: String!) {
    getClientDocumentTypes(entityId: $entityId) {
      statusCode
      message
      data
    }
  }
`;

export const GET_ASSOCIATIONS_FOR_DOCUMENT_REQUEST = gql`
  query ($entityId: String!) {
    getAssociationsForDocumentRequest(entityId: $entityId) {
      statusCode
      message
      data
    }
  }
`;
